import React from 'react';
import { Star } from 'lucide-react';
import { GALLERY, TESTIMONIALS } from '../../data/site';
import { Reveal } from '../common/Reveal';

export const Gallery = ({ title = 'Transformative Roofing Projects' }) => (
  <section className="py-24 bg-background" data-testid="gallery-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <span className="eyebrow justify-center">Our Work</span>
        <h2 className="section-title mt-4" data-testid="gallery-title">{title}</h2>
        <p className="mt-5 text-lg text-muted-foreground">
          Explore the Phoenix Roofing & Chimney portfolio, a testament to our transformative approach in roofing.
        </p>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-14">
        {GALLERY.map((g, i) => (
          <Reveal key={g.src} delay={(i % 4) * 0.06}>
            <div className="relative overflow-hidden rounded-2xl group" data-testid={`gallery-image-${i}`}>
              <img src={g.src} alt={g.alt} className="w-full h-[180px] md:h-[250px] object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-dark/55 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

const Stars = () => (
  <div className="flex items-center gap-0.5 text-[hsl(var(--accent))]">
    {[1, 2, 3, 4, 5].map((s) => <Star key={s} className="w-4 h-4 fill-current" />)}
  </div>
);

export const Testimonials = () => (
  <section className="py-24 bg-secondary" data-testid="testimonials-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <span className="eyebrow justify-center">Testimonials</span>
        <h2 className="section-title mt-4" data-testid="testimonials-title">Customers Testimonials</h2>
        <p className="mt-5 text-lg text-muted-foreground">
          Here’s what some of our customers have to say about our roofing services.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <div className="h-full rounded-2xl bg-card border border-border p-8 flex flex-col card-lift" data-testid={`testimonial-${t.name.replace(/[^a-zA-Z]+/g, '').toLowerCase()}`}>
              <Stars />
              <p className="mt-5 text-foreground/85 italic">{t.quote}</p>
              <div className="mt-auto pt-6 flex items-center gap-3.5">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" />
                <div>
                  <h3 className="font-heading font-bold text-[15px] leading-tight">{t.name.replace(/^-\s*/, '')}</h3>
                  <p className="text-muted-foreground text-[13px] mt-0.5">Verified Customer</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="text-center mt-12">
        <a
          href="https://www.google.com/search?q=phoenix+roofing+and+chimney+nj+reviews"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 font-heading font-bold text-primary underline-offset-4 hover:underline"
          data-testid="read-more-reviews"
        >
          Read more reviews
        </a>
      </Reveal>
    </div>
  </section>
);
